import React from "react";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Link } from "react-router-dom";

function itemsImages() {
  return (
    <Container className="spacingMin text-center">
      <Row>
        <Col md={12} className="noPadMob" data-aos={"fade"}>
          <div className="titleProcess" style={{ marginBottom: "50px" }}>
            What is developed
          </div>
        </Col>

        <Col md={4} data-aos={"fade"}>
          <div className="willContainBox">
            <img
              src="https://compilelabs.s3.ca-central-1.amazonaws.com/pictures/booking.png"
              className="itemsIcons"
            />
            {/* Icon by Freepik */}
            <div class="itemsTextArea">
              <div class="itemsTitle">Booking Apps</div>
              <div class="itemsText">
                We make apps that require a calendar and any form of booking.
                The use case would be, hotels, classes, online booking etc.
              </div>
            </div>
          </div>
        </Col>
        <Col md={4} className="noPad" data-aos={"fade"}>
          <div className="willContainBox">
            <img
              src="https://compilelabs.s3.ca-central-1.amazonaws.com/pictures/delivery-man.png"
              className="itemsIcons"
            />
            {/* Icon by Freepik */}
            <div class="itemsTextArea">
              <div class="itemsTitle">Delivery Apps</div>
              <div class="itemsText">
                Online stores are a necessity for sellers, we design and build
                online stores for clients in both web app form and mobile
                applications.
              </div>
              <div class="itemsNotice">Discounted Offer</div>

              <Link to="/orderingapp">
                <div class="offer">Learn More</div>
              </Link>
            </div>
          </div>
        </Col>
        <Col md={4} data-aos={"fade"}>
          <div className="willContainBox">
            <img
              src="https://compilelabs.s3.ca-central-1.amazonaws.com/pictures/browser.png"
              className="itemsIcons"
            />
            {/* Icon by prettycons */}
            <div class="itemsTextArea">
              <div class="itemsTitle">Custom Websites</div>
              <div class="itemsText">
                We make pages for information access. We make these pages
                stylish and contemporary so your users can enjoy exploring your
                page.
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default itemsImages;
